(() => {
  // app/scripts/blog-page.js
  var openDrawerButton = document.querySelector(".js-drawer-open");
  var drawerContainer = document.getElementById("sidebarDrawer");
  if (!!openDrawerButton) {
    openDrawerButton.addEvent("click", () => {
      drawerContainer.addClass("is-open");
      AT.disableScroll();
    });
    drawerContainer.querySelectorAll(".js-drawer-close").addEvents("click", () => {
      drawerContainer.removeClass("is-open");
      AT.enableScroll();
    });
  }
  var collapseButtons = document.querySelectorAll("#sidebarDrawer .js-btn-collapse");
  collapseButtons.forEach((button) => {
    let target = button.nextElementSibling;
    button.addEvent("click", function() {
      if (this.hasClass("is-open")) {
        this.removeClass("is-open");
        target.removeClass("is-open");
      } else {
        this.addClass("is-open");
        target.addClass("is-open");
      }
    });
  });
})();
